import React, { Component } from 'react';
import { Accordion, Button } from 'react-bootstrap';
import RadioButton from '../../../components/RadioButton/RadioButton';
import DataSlider from './DataSlider';

import DashboardAccordion from './DashboardAccordion';

// Import Style
import '../../../components/Filter/Filter.scss';

class ReportFilter extends Component {  
  
  static defaultProps = {
    onApply: () => {}
  }

  constructor(props) {
    super(props);
    this.count = 0;
    this.state = {
      rangeOptions: [
        { label: "Week", value: "lastWeek", number: 1, type: "week" },
        { label: "2 Weeks", value: "last2Week", number: 2, type: "week" },
        { label: "Month", value: "lastMonth", number: 1, type: "month" },    
        { label: "Quarter", value: "last3Month", number: 3, type: "month" }
      ],
      expandedFilters: ['controls', 'dateRange', 'threshold']
    }
  }

  handleUpdate = e => {
    this.setState(
      {
        [e.dashboardId]: e
      },
      () => {
        this.count++;
        if (this.count === this.props.dashboards.length) {
          this.applyFilters(true);
        }
      }
    );
  };

  handleChange = e => {
    if (e.name === 'percentile') {
      this.props.changePercentile(e.value);
    }
    if (e.name === 'dateRange') {
      this.props.changeDateRange(e.value);
    }
  };

  changeThreshold = e => {
    this.props.changeThreshold(e);
  }; 

  applyFilters = isInitial => {
    if (this.props.onApply) {
      this.props.onApply(this.state, isInitial);
    }
  };

  handleFilterSelect = e => {
    this.setState({
      expandedFilters: e
    });
  }

  renderControls() {
    return (
     
      <Accordion.Item eventKey="controls" key="controls" uuid="controls" activeKey={true}>
        <Accordion.Header>
          <React.Fragment><span className='title'>Controls</span></React.Fragment>
        </Accordion.Header>
        <Accordion.Body>
          <Accordion
            onSelect={e => this.handleFilterSelect(e)}
            activeKey={this.state.expandedFilters} alwaysOpen>
            {this.renderDateRange()}
            {this.renderThreshold()}              
          </Accordion>
        </Accordion.Body>
      </Accordion.Item>
    
    );
  }

  renderThreshold() {
    return (
      <Accordion.Item eventKey='threshold' key="threshold" uuid="threshold" activeKey={true}>
        <Accordion.Header>
          <React.Fragment>Variation</React.Fragment>
        </Accordion.Header>
        <Accordion.Body>
          <DataSlider threshold={this.props.threshold} changeThreshold={this.changeThreshold} />
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  renderDateRange() {
    const { rangeOptions } = this.state;
    const { dateRange } = this.props;
    const dateRanges = _.map(rangeOptions, (d) => {
      return (        
        <RadioButton
          key={d.value}
          label={d.label}
          id="dateRange"
          name="dateRange"
          value={d.value}
          checked={dateRange === d.value}
          onChange={this.handleChange}
        />
      );
    });
    return (
      <Accordion.Item eventKey='dateRange' key="dateRange" uuid="dateRange">
        <Accordion.Header>
          <React.Fragment>Group By</React.Fragment>
        </Accordion.Header>
        <Accordion.Body>  
          <div>  
            {dateRanges}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    );
  }

  render() {
    const { dashboards, controls, loading } = this.props;

    const items = dashboards.map((dashboard, i) => {
      return (
        <Accordion.Item eventKey={`acc_${i}`} key={`acc_${i}`} uuid={`acc_${i}`}>
          <Accordion.Header>
            <React.Fragment><span className='title'>{dashboard.name}</span></React.Fragment>
          </Accordion.Header>
          <Accordion.Body>
            {!loading && (<DashboardAccordion dashboard={dashboard} onChange={this.handleUpdate} />)}
          </Accordion.Body>
        </Accordion.Item>
      );
    });
    return (
      <div className='filter-postion-top'>
        <div className='btn-action' style={{ padding: '9px 25px', height: '60px' }}>
          <Button style={{ width: '100%' }} variant='light-secondary' disabled={loading} onClick={() => this.applyFilters()}>
            Apply filters
          </Button>
        </div>
        <Accordion className='filter'
          onSelect={e => this.handleFilterSelect(e)}
          activeKey={this.state.expandedFilters}
          alwaysOpen>
          {controls && !loading && this.renderControls()}
          {items}
        </Accordion>
      </div>
    );
  }
}

export default ReportFilter;
